import * as React from "react";
import {connect} from "react-redux";
import {RootState} from "../../../../store/reducer/root/RootState";
import User from "../../../../model/user/User";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import {Option} from "ts-option";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import SearchDropDown from "../../../../hiberUiKit/src/molecules/SearchDropDown/SearchDropDown";
import TextDropDownWrapper from "../../../../hiberUiKit/src/molecules/TextDropDownWrapper/TextDropDownWrapper";


interface IComponentProps {
	/**
	 * Partner brand identifier.
	 */
	partnerBrandId: Option<string>;
	/**
	 * Selected Partner Brand User id.
	 */
	partnerBrandUserId: Option<string>;
	/**
	 * Partner Brand User change callback.
	 * @param {User} user
	 */
	onChange?: (user: User) => void;
	/**
	 * Indicate if selection is removable (shows "x" button).
	 */
	removable?: boolean;
	/**
	 * On delete icon click callback. Remove selection.
	 * @param {React.MouseEvent<HTMLSpanElement>} evt
	 */
	onRemoveClick?: (evt: React.MouseEvent<HTMLSpanElement>) => void;

	/**
	 * Custom role title
	 */
	customRoleTitle?: string;
}

interface IReduxProps {
	/**
	 * All not disabled users belong to Partner Brand
	 */
	partnerBrandUsers: User[]
}

interface IState {
	/**
	 * Indicates if select partner brand user dropdown is visible.
	 */
	dropDownVisible: boolean;
}

type Props = IComponentProps & IReduxProps;

class PartnerBrandUserTPIESelector extends React.PureComponent<Props, IState> {
	public static defaultProps: Partial<Props> = {
		customRoleTitle: "Lead User"
	};

	constructor(props: Props) {
		super(props);
		this.state = {dropDownVisible: false};
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.onSelect = this.onSelect.bind(this);
	}

	render() {
		let partnerBrandUsers: User[] = this.props.partnerBrandUsers;
		const selectedPartnerBrandUser: User = this.props.partnerBrandUserId.map(pbuId => {
			partnerBrandUsers = partnerBrandUsers.filter(pbu => pbu.id != pbuId);
			return this.props.partnerBrandUsers.filter(pbu => pbu.id == pbuId)[0]
		}).orNull;
		const partnerBrandUserTxt = `${this.props.customRoleTitle}: ${selectedPartnerBrandUser ?
			selectedPartnerBrandUser.getDisplayName(true) : "Unassigned"}`;
		return (
			<TextDropDownWrapper text={partnerBrandUserTxt}
								 onClick={this.toggleDropdown}
								 onRemoveClick={this.props.onRemoveClick}
								 removable={this.props.removable}>
				{this.state.dropDownVisible &&
				<DropDownWrapper onOutsideClick={() => {this.setState({dropDownVisible: false})}}>
					<SearchDropDown items={partnerBrandUsers}
									onChange={this.onSelect}
									itemToLabel={(user: User) => user.getDisplayName()}
									itemToId={(user: User) => user.id}
									searchInputIcon={Icon.User}/>
				</DropDownWrapper>
				}
			</TextDropDownWrapper>
		);
	}

	toggleDropdown() {
		this.setState({dropDownVisible: !this.state.dropDownVisible});
	}

	onSelect(user: User) {
		this.toggleDropdown();
		this.props.onChange(user);
	}
}

function mapStateToProps(state: RootState, props: Props) {
	return {
		partnerBrandUsers: state.user.users.getOrElse([]).filter(
			u => u.data.partnerBrandId.orNull === props.partnerBrandId.orNull && !u.disabled && u.isThirdPartyEngineer())
	}
}

export default connect<IReduxProps, null, IComponentProps>(mapStateToProps)(PartnerBrandUserTPIESelector)